
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.797 8.707l-3.59 3.59a.692.692 0 01-.978 0L1.103 5.172A.332.332 0 011 4.904l.545-3.535a.341.341 0 01.323-.323L5.404.5a.332.332 0 01.268.102l7.125 7.126a.692.692 0 010 .978z","stroke":"#000C1F","stroke-opacity":".7","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M4.33 4.295a.462.462 0 100-.923.462.462 0 000 .923z","stroke":"#000C1F","stroke-opacity":".7","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    